import { useTranslation } from 'react-i18next';
import Footer from '@/components/feature/Footer';

interface PlaceholderPageProps {
  titleKey?: string;
  title?: string;
}

export default function PlaceholderPage({ titleKey, title }: PlaceholderPageProps) {
  const { t } = useTranslation('home');

  const displayTitle = title || (titleKey ? t(titleKey) : 'Page');

  return (
    <div className="min-h-screen bg-white">
      <main className="pt-8 md:pt-12 lg:pt-16 pb-16 md:pb-24">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto text-center py-20 md:py-32">
            <div className="w-16 h-16 rounded-full bg-cream-100 flex items-center justify-center mx-auto mb-6">
              <i className="ri-tools-line text-warm-500 text-2xl" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-ink-700 mb-4">
              {displayTitle}
            </h1>
            <p className="text-ink-400 mb-8">
              This page is coming soon. We are working hard to bring you the best experience.
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-ink-700 text-white font-medium rounded-lg hover:bg-ink-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-line" />
              Back to Home
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}